module.exports = __webpack_public_path__ + "img/rigth-slider.d12c05d8.svg";